export enum TicketIssueType {
  PROPERTY_DAMAGE = 'PROPERTY_DAMAGE',
  CONCERN = 'CONCERN',
  EMERGENCY = 'EMERGENCY',
}
